import React from "react";
import ApplicationUpdatesTable from "./ApplicationUpdatesTable";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { tableContainerStyles } from "../../../../../assets/styles/tableContainer";
import { getAuthorizationForPage } from "../../../../../helpers/AuthorizationHelper";
import SessionHelper from "../../../../../helpers/SessionHelper";
import UnauthorizedPage from "../../../../UnauthorizedPage";

export default function AdmProdApplicationUpdatesPage() {
  const permissions = SessionHelper.getUser().permissions;
  const authorization = getAuthorizationForPage(permissions, "admProdAppUpdate");
  return (
    <Container maxWidth={false} style={tableContainerStyles}>
      <Grid>
        {authorization?.view ? (
          <ApplicationUpdatesTable />
        ) : (
          <UnauthorizedPage />
        )}
      </Grid>
    </Container>
  );
}
